import {Schema, String as StringSchema, filter} from 'effect/Schema';

export const VirtualIban = StringSchema.pipe(
    filter((value: string) => /^[A-Z0-9]+$/.test(value), {
        identifier: 'VirtualIban',
    })
) as unknown as Schema<VirtualIban>;
export type VirtualIban = import('../src/VirtualIban').VirtualIban;
